export const clone = data => JSON.parse(JSON.stringify(data));

export const isnull = (data, fallback) => {
    if (data == null)
        return fallback;
    return data;
}